import { createSlice } from "@reduxjs/toolkit";

const userSlice = createSlice({
  name: "user",
  initialState: { user: {}},
  reducers: {
    fetchUserSuccess(state, action) {
      const { userObj } = action.payload;
      state.user = userObj;
    },
    fetchAutoPilotPaymentMethodSuccess(state, action) {
      const { paymentMethod } = action.payload;
      state.user.feature_access.autopilot.payment_method = paymentMethod;
    },
    fetchAutoPilotFreeTrialSuccess(state) {
      state.user.feature_access = {
        "autopilot": {
          "fast_entry": {
            "trial_end": false,
            "enabled": true,
            "tier": "autopilot_standard"
          }
        }
      }
    },
    fetchAutoPilotPlanChangesSuccess(state, action) {
      const { tier } = action.payload;
      const today = new Date();
      const futureDate = new Date(today);
      futureDate.setDate(today.getDate() + 30);
      const formattedDate = futureDate.toISOString();
      if (tier === "standard") {
        state.user.feature_access.autopilot.fast_entry = {
          ...state.user.feature_access.autopilot.fast_entry,
          "tier": "autopilot_standard",
          "trial_end": null,
          "current_period_end": formattedDate,
          "enabled": true
        }
        state.user.feature_access.autopilot.printavo = {
          ...state.user.feature_access.autopilot.printavo,
          "enabled": false,
          "tier": null,
        }
      } else if (tier === "premium") {
        state.user.feature_access.autopilot.printavo = {
          ...state.user.feature_access.autopilot.printavo,
          "tier": "autopilot_premium",
          "trial_end": null,
          "current_period_end": formattedDate,
          "enabled": true
        }
      }
    },
    logout(state) {
      state.user = {};
    },
  },
});

export default userSlice.reducer;

export const selectUser = (state) => state.user.user;
export const selectAutoPilotPaymentMethod = (state) => state.user.user.feature_access?.payment_method;

export const {
  fetchUserSuccess,
  fetchAutoPilotPaymentMethodSuccess,
  fetchAutoPilotFreeTrialSuccess,
  fetchAutoPilotPlanChangesSuccess,
  logout,
} = userSlice.actions;
